import { render, staticRenderFns } from "./placesLived.vue?vue&type=template&id=20eca556&scoped=true"
import script from "./placesLived.vue?vue&type=script&lang=js"
export * from "./placesLived.vue?vue&type=script&lang=js"
import style0 from "./placesLived.vue?vue&type=style&index=0&id=20eca556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eca556",
  null
  
)

export default component.exports